document.addEventListener('DOMContentLoaded', function () {
  const annoSliders = document.querySelectorAll('.announcement-bar-slider');
  annoSliders.forEach(function (container) {
    const closeBtn = container.querySelector('.announcement-bar__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        container.style.display = 'none';
      });
    }
    const userSwiperEl = container.querySelector('.announcement-bar-swiper');
    const annoinfi = container.querySelector('.announcement-bar__inner');
    const swiperWrapper = userSwiperEl.querySelector('.swiper-wrapper');
    
    if (annoinfi.classList.contains('infinite_slider')) {
     const slides = swiperWrapper.querySelectorAll('.swiper-slide');
      if (slides.length < 8) {
        slides.forEach((slide) => {
          const clone1 = slide.cloneNode(true);
          const clone2 = slide.cloneNode(true);
          swiperWrapper.appendChild(clone1);
          swiperWrapper.appendChild(clone2);
        });
      }
      userSwiper = new Swiper(userSwiperEl, {
        spaceBetween: 30,
        loop: true,
        speed: 6500,
        slidesPerView: 'auto',
        freeMode: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: false
        },
      });
    } else {
      userSwiper = new Swiper(userSwiperEl, {
        spaceBetween: 30,
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        speed: 800,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
      });
    }
    });
  });